<template>
  <BaseDataTable :data="contactRequests">
    <template #header>
      <thead class="bg-gray-50">
        <tr>
          <th
            scope="col"
            class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            Contact Request
          </th>
          <th
            scope="col"
            class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            Address
          </th>
          <th
            scope="col"
            class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            Status
          </th>
          <th
            scope="col"
            class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            Delivery Status
          </th>
          <th
            scope="col"
            class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-0"
          />
        </tr>
      </thead>
    </template>
    <template #default="{ item }">
      <ContactRequestListItem
        :key="item.id"
        :contact-request="item"
        :email-message="emailMessage"
        :send-disabled="sendDisabled"
        :on-send-email-message="onSendEmailMessage"
      />
    </template>
  </BaseDataTable>
</template>

<script>
import ContactRequestListItem from './ContactRequestListItem.vue';

export default {
  components: {
    ContactRequestListItem,
  },
  props: {
    contactRequests: {
      type: Array,
      default: () => [],
    },
    emailMessage: {
      type: Object,
      required: true,
    },
    onSendEmailMessage: {
      type: Function,
      required: true,
    },
    sendDisabled: Boolean,
  },
};
</script>
